const employerQuery = (id) => {
    return `
    query {
        getEmployerById(id: "${id}") {
          id
          group_id,
          form_id,
          user_id,
          EmployerFormData {
            new_profile_emp_legal_name
            new_profile_emp_dba
            new_profile_emp_address1
            new_profile_emp_address2
            new_profile_emp_city
            new_profile_emp_state_id
            new_profile_emp_zip
            new_profile_emp_country_id
            new_profile_emp_province
            new_profile_emp_phone
            new_profile_emp_phone_ext
            new_profile_emp_fein
            new_profile_emp_naics
            new_profile_emp_naics_description
            new_profile_emp_profile_name
            new_profile_emp_year_commenced
          }
        }
      }
      `
}

export default employerQuery